import React, { useContext, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { MeetingInstance } from "@services/meetings/types";
import { FormContext } from "../context/formContext";
import Button from "@common/components/Button";
import { displayDateTime } from "@common/utils/localTime.utils";

interface PickMeetingDialogProps {
  meetings: MeetingInstance[];
  open?: boolean;
  onClose?: () => void;
}

const PickMeetingDialog = (props: PickMeetingDialogProps) => {
  const { open = false, onClose = () => {}, meetings } = props;
  const { t } = useTranslation();
  const { form, dispatchHasChanged } = useContext(FormContext);
  const { ticket } = form;
  const [meetingId, setMeetingId] = useState<string>(
    meetings.length > 0 ? "" + meetings[0].id : ""
  );
  const [errorMeetingId, setErrorMeetingId] = useState<string>("");

  const getMeetingLabel = (meeting: MeetingInstance) => {
    let tmp = `${meeting.meetingId} - ${meeting.title} (${t(
      "from"
    )} ${displayDateTime(meeting.start)} ${t("till")} ${displayDateTime(
      meeting.end
    )})`;

    return tmp;
  };

  const onConfirm = async () => {
    if (meetingId != "") {
      var meeting = meetings.find((meeting) => meeting.id == Number(meetingId));

      if (meeting) {
        let smallmeeting = {
          confirmationNumber: meeting.meetingId,
          title: meeting.title,
          meetingInstanceId: meeting.id,
        };
        if (!ticket?.meetings) ticket.meetings = [];
        ticket?.meetings?.push(smallmeeting);
        onClose();
      }
    } else {
      setErrorMeetingId(t("Field is required"));
    }
  };

  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <DialogTitle>
        {t("Please select only one meeting that has been affected.")}
      </DialogTitle>
      <DialogContent>
        <FormControl
          fullWidth
          sx={(theme) => ({
            marginTop: 2,
            width: "100%",
            "& .MuiFormHelperText-root": {
              color: theme.palette.error.main,
            },
            "& .MuiInputLabel-root::after": {
              content: "'*'",
              color: theme.palette.error.main,
            },
          })}
        >
          <RadioGroup
            value={meetingId}
            onChange={(e) => {
              setMeetingId(e.target.value), dispatchHasChanged(true);
            }}
            name="radio-meetings-group"
          >
            {meetings.map((meeting) => (
              <FormControlLabel
                value={meeting.id}
                control={<Radio id={`radio-${meeting.id}`} />}
                label={getMeetingLabel(meeting)}
                key={`formcontrol-label-${meeting.id}`}
              />
            ))}
          </RadioGroup>
          <FormHelperText>{errorMeetingId}</FormHelperText>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="white" onClick={onConfirm}>
          {t("Add Meeting")}
        </Button>
        <Button variant="outlined" color="greyed" onClick={onClose}>
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PickMeetingDialog;
